import { HeroCatalogSchema, ROUTES, type HeroCatalogItem } from "@scrile/contracts";

const CATALOG_TIMEOUT_MS = 10_000;

export interface CatalogRequestOptions {
  fetch?: typeof fetch;
  signal?: AbortSignal;
  timeoutMs?: number;
}

/**
 * Публичный каталог общей витрины. Он намеренно не входит в HeroApi: на корневом
 * домене нет выбранного героя и, следовательно, нет ApiProvider.
 */
export async function loadHeroCatalog(options: CatalogRequestOptions = {}): Promise<HeroCatalogItem[]> {
  const doFetch = options.fetch ?? ((input, init) => fetch(input, init));
  const controller = new AbortController();
  const outer = options.signal;
  const onOuterAbort = () => controller.abort();
  if (outer?.aborted) controller.abort();
  else outer?.addEventListener("abort", onOuterAbort, { once: true });
  const timer = setTimeout(() => controller.abort(), options.timeoutMs ?? CATALOG_TIMEOUT_MS);

  try {
    const response = await doFetch(ROUTES.catalogHeroes, {
      method: "GET",
      credentials: "omit",
      headers: { accept: "application/json" },
      signal: controller.signal,
    });
    if (!response.ok) throw new Error(`GET ${ROUTES.catalogHeroes} returned ${response.status}`);
    const data: unknown = await response.json();
    return HeroCatalogSchema.parse(data).heroes;
  } finally {
    clearTimeout(timer);
    outer?.removeEventListener("abort", onOuterAbort);
  }
}
